import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getOverrides, useClasses } from '../../../utils/overrides';
import Icon from '../../general/Icon';
import { createUseStyles, useTheme } from '../../../utils/styles';
import styles from './styles';
const useStyles = createUseStyles(styles, 'Checkbox');
const defaultColors = process.env.NODE_ENV !== "production" ? ['neutral', 'red', 'orange', 'green', 'blue', 'purple', 'aqua', 'yellow', 'turquoise'] : {};
function Checkbox(_ref) {
  let {
    children,
    classes: classesProp,
    overrides: overridesProp,
    className: classNameProp,
    checked,
    indeterminate,
    isDisabled,
    onChange,
    size,
    color: colorProp,
    isMonotone,
    ...props
  } = _ref;
  const theme = useTheme();
  const classes = useClasses(useStyles, classesProp);
  // Overrides
  const override = getOverrides(overridesProp, Checkbox.overrides);

  // Classes
  const rootClassName = classnames(classes.root, {
    [classes.disabled]: isDisabled
  }, classNameProp);
  const getColor = useCallback(checkState => {
    if (isMonotone) {
      if (colorProp === 'neutral') {
        return isDisabled ? theme.colors.neutral500 : theme.colors.neutral700;
      }
      return isDisabled ? theme.colors["".concat(colorProp, "200")] || theme.colors.neutral500 : theme.colors["".concat(colorProp, "500")] || theme.colors.neutral700;
    } else {
      if (checkState === 'unchecked') {
        return isDisabled ? theme.colors.neutral500 : theme.colors.neutral700;
      } else {
        return isDisabled ? theme.colors["".concat(colorProp, "200")] || theme.colors.neutral500 : theme.colors["".concat(colorProp, "500")] || theme.colors.neutral700;
      }
    }
  }, [colorProp, isDisabled, theme.colors, isMonotone]);
  const rootProps = {
    className: rootClassName,
    onClick: !isDisabled ? onChange : undefined
  };
  let checkState = 'unchecked';
  if (checked && indeterminate) checkState = 'indeterminate';else if (checked) checkState = 'checked';
  return /*#__PURE__*/React.createElement("div", _extends({}, rootProps, override.root), checkState === 'checked' && /*#__PURE__*/React.createElement(Icon, _extends({
    name: "checkBox",
    size: size,
    color: getColor('checked')
  }, override.svg)), checkState === 'unchecked' && /*#__PURE__*/React.createElement(Icon, _extends({
    name: "checkBoxOutlineBlank",
    size: size,
    color: getColor('unchecked')
  }, override.svg)), checkState === 'indeterminate' && /*#__PURE__*/React.createElement(Icon, _extends({
    name: "indeterminateCheckBox",
    size: size,
    color: getColor('indeterminate')
  }, override.svg)), /*#__PURE__*/React.createElement("input", _extends({
    className: classes.input,
    onChange: !isDisabled ? onChange : undefined,
    type: "checkbox",
    checked: checked ? 'checked' : '',
    value: checkState,
    disabled: isDisabled ? 'disabled' : ''
  }, override.input)));
}
Checkbox.overrides = ['root', 'input', 'svg'];
Checkbox.defaultProps = {
  onChange: () => {},
  overrides: {},
  color: 'neutral',
  size: 'medium'
};
process.env.NODE_ENV !== "production" ? Checkbox.propTypes = {
  className: PropTypes.string,
  overrides: PropTypes.object,
  checked: PropTypes.bool,
  indeterminate: PropTypes.bool,
  onChange: PropTypes.func,
  isDisabled: PropTypes.bool,
  color: PropTypes.oneOf(defaultColors),
  size: PropTypes.oneOf(['small', 'medium', 'large', 'big', 'huge']),
  isMonotone: PropTypes.bool
} : void 0;
export default /*#__PURE__*/React.memo(Checkbox);